<template>
  <footer
    v-if="routeType !== 'become author'"
    class="glass-effect relative px-10"
  >
    <div class="absolute inset-x-0 z-30  px-3 md:px-6 2xl:px-0 glass-effect">
      <div
        v-if="
          routeType !== 'login' &&
            routeType !== 'register' &&
            routeType !== 'checkout'
        "
        class="py-12 border-b border-gray-600"
      >
        <div
          class="max-w-1xl xl:px-0 mx-auto grid grid-cols-1 md:grid-cols-2 justify-between"
        >
          <!-- links -->
          <div
            class="grid grid-cols-3 space-x-10 items-start place-items-center lg:place-items-start"
          >
            <div>
              <h3
                class="uppercase font-semibold text-xs md:text-sm tracking-wide mb-6 text-gray-400"
              >
                {{ footerLinks[0].title }}
              </h3>
              <div class="mt-3 flex flex-col space-y-4">
                <a
                  v-for="link in footerLinks[0].links"
                  :key="link.url"
                  :href="link.url"
                  class="text-xs text-white hover:underline hover:font-semibold cursor-pointer"
                  >{{ link.name }}
                </a>
              </div>
            </div>

            <div>
              <h3
                class="uppercase font-semibold text-xs md:text-sm tracking-wide mb-6 text-gray-400"
              >
                {{ footerLinks[1].title }}
              </h3>
              <div class="mt-3 flex flex-col space-y-4">
                <a
                  v-for="link in footerLinks[1].links"
                  :key="link.url"
                  :href="link.url"
                  class="text-xs text-white hover:underline hover:font-semibold cursor-pointer"
                  >{{ link.name }}
                </a>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-8">
              <div>
                <h3
                  class="uppercase font-semibold text-xs md:text-sm tracking-wide mb-6 text-gray-400"
                >
                  {{ footerLinks[2].title }}
                </h3>
                <div class="mt-3 flex flex-col space-y-4">
                  <a
                    v-for="link in footerLinks[2].links"
                    :key="link.url"
                    :href="link.url"
                    class="text-xs text-white hover:underline hover:font-semibold cursor-pointer"
                    >{{ link.name }}
                  </a>
                  <!-- 	<span
											v-if="link.badge"
											style="background-color:#f48b29"
											class="rounded-full ml-2 text-xxs p-1 text-gray-800 font-bold"
										>
											{{ link.badge }}
										</span> -->
                </div>
              </div>

              <div>
                <h3
                  class="uppercase font-semibold text-xs md:text-sm tracking-wide mb-6 text-gray-400"
                >
                  {{ footerLinks[3].title }}
                </h3>
                <div class="mt-3 flex flex-col space-y-4">
                  <a
                    v-for="link in footerLinks[3].links"
                    :key="link.url"
                    :href="link.url"
                    class="text-xs text-white hover:underline hover:font-semibold cursor-pointer"
                    >{{ link.name }}
                  </a>
                  <!-- 	<span
											style="background-color:#29bb89"
											v-if="link.badge"
											class="rounded-full ml-2 text-xxs p-1 text-gray-800 font-bold"
										>
											{{ link.badge }}
										</span> -->
                </div>
              </div>
            </div>
          </div>

          <!-- company info -->
          <div class="flex flex-col items-center mt-4 lg:mt-0 md:items-end">
            <!-- title -->
            <svg
              class="w-40 mb-6 text-white"
              viewBox="0 0 809 110"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M492.81 55.6599C492.81 60.8199 491.9 65.5599 490.07 69.8699C488.24 74.1899 485.71 77.9099 482.47 81.0599C479.23 84.1999 475.41 86.6399 471 88.3799C466.59 90.1099 461.85 90.9799 456.79 90.9799C451.72 90.9799 446.99 90.1099 442.58 88.3799C438.17 86.6499 434.37 84.2099 431.18 81.0599C427.99 77.9199 425.48 74.1899 423.65 69.8699C421.82 65.5599 420.91 60.8199 420.91 55.6599C420.91 50.4999 421.82 45.7899 423.65 41.5199C425.48 37.2499 427.99 33.5699 431.18 30.4799C434.37 27.3799 438.17 24.9699 442.58 23.2299C446.99 21.4999 451.73 20.6299 456.79 20.6299C461.85 20.6299 466.59 21.4999 471 23.2299C475.41 24.9699 479.23 27.3799 482.47 30.4799C485.71 33.5799 488.24 37.2599 490.07 41.5199C491.89 45.7899 492.81 50.4999 492.81 55.6599ZM479.02 55.7299C479.02 52.5499 478.53 49.5099 477.54 46.6099C476.55 43.7099 475.12 41.1599 473.24 38.9699C471.36 36.7699 469.03 35.0199 466.25 33.7099C463.47 32.3999 460.3 31.7399 456.72 31.7399C453.14 31.7399 449.97 32.3999 447.19 33.7099C444.41 35.0199 442.08 36.7699 440.2 38.9699C438.32 41.1699 436.88 43.7199 435.9 46.6099C434.91 49.5099 434.42 52.5499 434.42 55.7299C434.42 58.9099 434.91 61.9499 435.9 64.8499C436.89 67.7499 438.32 70.3199 440.2 72.5699C442.08 74.8099 444.41 76.5899 447.19 77.8999C449.96 79.2099 453.14 79.8599 456.72 79.8599C460.29 79.8599 463.47 79.2099 466.25 77.8999C469.02 76.5899 471.35 74.8099 473.24 72.5699C475.12 70.3299 476.55 67.7499 477.54 64.8499C478.52 61.9499 479.02 58.9099 479.02 55.7299Z"
                  fill="currentColor"
                />
                <path
                  d="M386.81 54.1102L362.47 22.4502H374.67C377.26 22.4502 379.69 23.7002 381.19 25.8102L395.12 45.3802L410.65 23.7402C411.23 22.9302 412.17 22.4502 413.17 22.4502H420.78C423.35 22.4502 424.81 25.3902 423.25 27.4402L403 53.9702L426.06 84.1602C427.62 86.2002 426.16 89.1502 423.59 89.1502H415C414 89.1502 413.06 88.6702 412.47 87.8502L394.83 63.1202L376.9 87.8602C376.32 88.6702 375.38 89.1402 374.39 89.1402H366.35C363.78 89.1402 362.32 86.2002 363.88 84.1502L386.81 54.1102Z"
                  fill="currentColor"
                />
                <path
                  d="M346 46.0202C346 41.0502 344.5 37.3702 341.5 34.9802C338.5 32.5902 334.51 31.3902 329.54 31.3902C325.79 31.3902 322.25 32.1202 318.92 33.5702C316.62 34.5802 314.57 35.7702 312.79 37.1602C311.47 38.1802 309.59 37.9802 308.53 36.7002L305.48 33.0402C304.34 31.6702 304.6 29.6502 306.01 28.5702C308.77 26.4602 311.95 24.7302 315.55 23.3702C320.29 21.5902 325.37 20.7002 330.82 20.7002C335.6 20.7002 339.75 21.3802 343.27 22.7402C346.79 24.1002 349.67 25.9502 351.92 28.3002C354.17 30.6402 355.86 33.4102 356.99 36.6002C358.12 39.7902 358.68 43.2102 358.68 46.8702V75.9902C358.68 78.2402 358.75 80.6102 358.89 83.1002L359.24 89.2202H351.59C349.26 89.2202 347.27 87.5002 346.96 85.1802C346.71 83.3402 346.58 81.4902 346.58 79.6502H346.16C343.72 83.2202 340.65 85.9802 336.94 87.9502C333.23 89.9202 328.85 90.9002 323.78 90.9002C321.15 90.9002 318.41 90.5502 315.55 89.8502C312.69 89.1502 310.08 88.0002 307.74 86.4002C305.4 84.8102 303.45 82.7002 301.9 80.0702C300.35 77.4502 299.58 74.2102 299.58 70.3602C299.58 65.2902 300.94 61.2802 303.66 58.3302C306.38 55.3702 309.94 53.1202 314.35 51.5802C318.76 50.0302 323.73 49.0202 329.26 48.5602C334.79 48.0902 340.38 47.8602 346 47.8602V46.0202V46.0202ZM342.77 57.4202C339.49 57.4202 336.09 57.5602 332.57 57.8402C329.05 58.1202 325.86 58.6802 323 59.5302C320.14 60.3702 317.77 61.6402 315.89 63.3302C314.01 65.0202 313.08 67.2702 313.08 70.0802C313.08 72.0502 313.48 73.6902 314.28 75.0002C315.08 76.3202 316.13 77.3902 317.45 78.2402C318.76 79.0802 320.22 79.6702 321.81 80.0002C323.4 80.3302 325.05 80.4902 326.73 80.4902C332.92 80.4902 337.68 78.6402 341.01 74.9302C344.34 71.2302 346 66.5602 346 60.9302V57.4102H342.77V57.4202Z"
                  fill="currentColor"
                />
                <path
                  d="M273.54 89.15H265.93C263.9 89.15 262.07 87.92 261.3 86.04L235.42 22.47C235.42 22.46 235.42 22.46 235.43 22.46H244.49C247.83 22.46 250.82 24.54 251.99 27.67L269.61 74.94H269.89L288.83 24.47C289.28 23.26 290.44 22.46 291.74 22.46H299.07C301.27 22.46 302.77 24.68 301.95 26.72L278.18 86.01C277.42 87.9 275.58 89.15 273.54 89.15Z"
                  fill="currentColor"
                />
                <path
                  d="M195.401 54.1102L171.061 22.4502H183.261C185.851 22.4502 188.281 23.7002 189.781 25.8102L203.711 45.3802L219.241 23.7402C219.821 22.9302 220.761 22.4502 221.761 22.4502H229.371C231.941 22.4502 233.401 25.3902 231.841 27.4402L211.591 53.9702L234.651 84.1602C236.211 86.2002 234.751 89.1502 232.181 89.1502H223.591C222.591 89.1502 221.651 88.6702 221.061 87.8502L203.421 63.1202L185.501 87.8702C184.921 88.6802 183.981 89.1502 182.991 89.1502H174.951C172.381 89.1502 170.921 86.2102 172.481 84.1602L195.401 54.1102Z"
                  fill="currentColor"
                />
                <path
                  d="M173.61 55.2401C173.61 55.9901 173.61 56.7401 173.61 57.4901C173.61 58.7301 172.6 59.7401 171.36 59.7401H120.43C120.52 62.5401 121.16 65.1701 122.33 67.6301C123.5 70.1001 125.07 72.2401 127.04 74.0601C129.01 75.8801 131.28 77.3001 133.86 78.3201C136.44 79.3401 139.18 79.8601 142.09 79.8601C146.59 79.8601 150.48 78.8701 153.77 76.9001C157.05 74.9301 159.63 72.5401 161.51 69.7201L166.27 73.5501C168.9 75.6601 169.05 79.5801 166.62 81.8801C164.07 84.3001 161.26 86.2101 158.2 87.6201C153.37 89.8501 148 90.9701 142.09 90.9701C137.02 90.9701 132.33 90.1301 128.02 88.4401C123.7 86.7501 120 84.3801 116.9 81.3301C113.8 78.2801 111.36 74.6001 109.58 70.2901C107.8 65.9801 106.91 61.1901 106.91 55.9401C106.91 50.7801 107.78 46.0201 109.52 41.6601C111.26 37.3001 113.68 33.5701 116.78 30.4701C119.88 27.3701 123.55 24.9601 127.78 23.2201C132.01 21.4901 136.57 20.6201 141.46 20.6201C146.35 20.6201 150.79 21.4201 154.79 23.0101C158.78 24.6101 162.17 26.9001 164.94 29.9001C167.71 32.9001 169.85 36.5401 171.36 40.8001C172.86 45.0901 173.61 49.8901 173.61 55.2401ZM160.11 49.8901C160.02 47.2701 159.57 44.8001 158.77 42.5001C157.97 40.2001 156.8 38.2101 155.25 36.5201C153.7 34.8301 151.78 33.5001 149.48 32.5101C147.18 31.5201 144.48 31.0301 141.39 31.0301C138.58 31.0301 135.92 31.5201 133.44 32.5101C130.95 33.5001 128.8 34.8301 126.97 36.5201C125.14 38.2101 123.64 40.2001 122.47 42.5001C121.3 44.8001 120.62 47.2601 120.43 49.8901C120.49 49.8901 160.11 49.8901 160.11 49.8901Z"
                  fill="currentColor"
                />
                <path
                  d="M86.37 70.6899C82.76 76.9599 77.61 82.0299 71.55 85.5299C65.5 89.0399 58.54 90.9799 51.3 90.9799H51.24C36.8 90.9799 23.44 83.2699 16.2 70.7599C12.57 64.4799 10.75 57.4699 10.75 50.4699C10.75 43.4899 12.55 36.5099 16.16 30.2499L23.82 16.9499C26.3 12.6399 30.9 9.97994 35.87 9.96994C38.4 9.96994 40.83 10.6499 42.93 11.8899C45.04 13.1199 46.82 14.8999 48.05 17.1099L51.56 23.3899L51.7 23.6399L62.37 42.6899L63.53 44.7499C63.68 45.0199 63.82 45.2999 63.94 45.5899C64.53 47.0999 64.85 48.7499 64.85 50.4699C64.85 52.1299 64.55 53.7199 64 55.1799C62.09 60.3099 57.15 63.9599 51.36 63.9599C46.99 63.9599 43.11 61.8799 40.66 58.6499C40.49 58.4299 40.33 58.1999 40.17 57.9699C40.14 57.9399 40.13 57.9199 40.12 57.8999C39.99 57.7099 39.86 57.5099 39.74 57.2999C39.69 57.2199 39.64 57.1299 39.6 57.0499C39.49 56.8499 39.38 56.6499 39.28 56.4499C39.15 56.1999 39.04 55.9399 38.93 55.6799C38.8 55.3899 38.69 55.0899 38.59 54.7899C38.57 54.7499 38.56 54.7099 38.55 54.6799C38.55 54.6699 38.54 54.6599 38.54 54.6499C38.46 54.4099 38.39 54.1599 38.32 53.9099C38.28 53.7699 38.25 53.6299 38.21 53.4899C38.19 53.3899 38.17 53.2899 38.15 53.1899C38.13 53.1099 38.12 53.0199 38.1 52.9399C38.08 52.8599 38.07 52.7699 38.05 52.6899C38.05 52.6599 38.05 52.6299 38.04 52.5999C38.03 52.5399 38.02 52.4699 38.01 52.3999C37.92 51.7699 37.87 51.1199 37.87 50.4699C37.87 49.7899 37.92 49.1199 38.02 48.4699C38.02 48.4499 38.03 48.4199 38.03 48.3999C38.05 48.3099 38.06 48.2099 38.08 48.1199C38.08 48.0999 38.08 48.0799 38.09 48.0599C38.11 47.9599 38.13 47.8599 38.15 47.7499C38.17 47.6499 38.19 47.5499 38.21 47.4599C38.24 47.3199 38.28 47.1799 38.32 47.0399C38.39 46.7599 38.48 46.4699 38.57 46.1999C38.64 45.9899 38.71 45.7899 38.8 45.5899C38.82 45.4899 38.86 45.3999 38.9 45.3099C39.01 45.0599 39.12 44.8199 39.24 44.5699C39.37 44.3099 39.51 44.0499 39.66 43.7899L39.91 43.3299L41.54 40.5199L41.53 40.5099C42.09 39.5399 42.42 38.4199 42.42 37.2199C42.42 33.6099 39.49 30.6899 35.89 30.6899C33.91 30.6899 32.14 31.5599 30.95 32.9499H30.94C29.84 34.2199 28.86 35.5999 28.01 37.0799C25.62 41.2199 24.42 45.8399 24.42 50.4699C24.42 55.1099 25.63 59.7499 28.04 63.9099C32.84 72.1999 41.68 77.2999 51.26 77.2999H51.29C56.08 77.2999 60.7 76.0099 64.7 73.6899C68.71 71.3699 72.12 68.0199 74.51 63.8599L74.61 63.6899C79.35 55.4699 79.39 45.3699 74.73 37.1099L65 19.8699C62.5 15.4299 65.7 9.93994 70.8 9.93994C73.17 9.93994 75.34 11.2099 76.53 13.2499L86.32 30.1799C93.57 42.6999 93.59 58.1499 86.37 70.6899Z"
                  fill="#20DE82"
                />
                <path
                  d="M790.5 100.86H516.54C513.09 100.86 510.3 98.0699 510.3 94.6199V17.0999C510.3 13.6499 513.09 10.8599 516.54 10.8599H796.74V94.6199C796.74 98.0599 793.94 100.86 790.5 100.86Z"
                  fill="#20DE82"
                />
                <path
                  d="M521.1 91.3298V20.5298H546C550.33 20.5298 554.05 21.1298 557.15 22.3298C560.25 23.5298 562.6 25.1498 564.2 27.1798C565.8 29.2098 566.95 31.2998 567.65 33.4298C568.35 35.5598 568.7 37.8598 568.7 40.3298C568.7 44.9998 567.1 49.1298 563.9 52.7298C560.7 56.3298 556.5 58.4298 551.3 59.0298L571.4 91.3298H562.29C560.5 91.3298 558.85 90.3798 557.96 88.8298L541.4 60.1298H530.7V86.3298C530.7 89.0898 528.46 91.3298 525.7 91.3298H521.1V91.3298ZM530.7 28.9298V51.7298H543.3C553.43 51.7298 558.5 47.9298 558.5 40.3298C558.5 32.7298 553.43 28.9298 543.3 28.9298H530.7V28.9298Z"
                  fill="white"
                />
                <path
                  d="M579.199 91.3298V20.5298H583.799C586.559 20.5298 588.799 22.7698 588.799 25.5298V91.3298H579.199Z"
                  fill="white"
                />
                <path
                  d="M599.399 91.3298V25.5298C599.399 22.7698 601.639 20.5298 604.399 20.5298H624.099C629.829 20.5298 634.949 21.3498 639.449 22.9798C643.949 24.6098 647.529 26.6798 650.199 29.1798C652.869 31.6798 655.069 34.5598 656.799 37.8298C658.529 41.0998 659.719 44.2098 660.349 47.1798C660.979 50.1498 661.299 53.0598 661.299 55.9298C661.299 60.5298 660.449 64.9298 658.749 69.1298C657.049 73.3298 654.619 77.0998 651.449 80.4298C648.279 83.7598 644.199 86.4098 639.199 88.3798C634.199 90.3498 628.629 91.3298 622.499 91.3298H599.399ZM608.999 29.5298V82.3298H621.099C629.629 82.3298 636.769 80.0298 642.499 75.4298C648.229 70.8298 651.099 64.3298 651.099 55.9298C651.099 53.8598 650.879 51.7798 650.449 49.6798C650.019 47.5798 649.179 45.2798 647.949 42.7798C646.719 40.2798 645.119 38.0798 643.149 36.1798C641.179 34.2798 638.499 32.6998 635.099 31.4298C631.699 30.1598 627.799 29.5298 623.399 29.5298H608.999V29.5298Z"
                  fill="white"
                />
                <path
                  d="M706.79 51.9098H731V85.2998C727.81 87.2098 723.82 88.7298 719.04 89.8398C714.26 90.9598 709.69 91.5098 705.36 91.5098C694.26 91.5098 685.44 88.0798 678.91 81.2198C672.37 74.3598 669.1 65.9298 669.1 55.9098C669.1 45.7698 672.42 37.2998 679.05 30.5098C685.68 23.7198 694.13 20.3198 704.4 20.3198C715.56 20.3198 723.98 23.2498 729.66 29.1198L726.33 32.6898C724.65 34.4898 721.9 34.8098 719.88 33.4198C715.52 30.4198 710.36 28.9198 704.4 28.9198C696.81 28.9198 690.65 31.5198 685.93 36.7198C681.21 41.9198 678.85 48.3098 678.85 55.8998C678.85 63.5498 681.37 69.9598 686.41 75.1298C691.45 80.2998 697.7 82.8798 705.16 82.8798C712.05 82.8798 717.6 81.6998 721.81 79.3398V60.5298H711.79C709.03 60.5298 706.79 58.2898 706.79 55.5298V51.9098V51.9098Z"
                  fill="white"
                />
                <path
                  d="M740.899 91.3298V20.5298H781.599C784.359 20.5298 786.599 22.7698 786.599 25.5298V29.5298H750.499V50.6298H784.099V59.6298H750.499V82.3298H788.399V86.3298C788.399 89.0898 786.159 91.3298 783.399 91.3298H740.899Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="808.59" height="109.76" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <!-- content -->
            <h2
              class="mb-5 md:my-0 md:mt-3 text-xs md:text-sm text-white text-center md:text-right max-w-xs"
            >
              Top Creative digital assets on Vooaxis Market. Everything you're
              looking for from project files and video templates - its here
            </h2>

            <div class="mt-3 xl:mt-10 flex space-x-10">
              <!-- <div class="flex flex-col items-center md:items-end ">
								<span class="text-xxs md:text-xs text-gray-400"
									>Premium Resources</span
								>
								<h1 class="text-white font-bold text-lg md:text-xl">1,569</h1>
							</div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- copyrights -->
      <div
        class="my-3 2xl:pb-5 w-full flex max-w-1xl mx-auto flex-col md:flex-row md:items-center items-center justify-center md:justify-between"
      >
        <p class="text-gray-500 text-xs md:text-sm text-center md:text-left">
          &copy; {{ getDate }} Vooaxis Pvt Ltd. All rights reserved
        </p>

        <div class="mt-1 md:mt-0 flex gap-2 md:-space-x-3">
          <a
            href="https://www.facebook.com/vooaxis"
            target="_blank"
            class="cursor-pointer p-2 hover:text-gray-200 text-gray-400 rounded-full transition-colors duration-300"
          >
            <svg
              class="h-6 w-6"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999c0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891c1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"
                fill="currentColor"
              />
              <rect
                x="0"
                y="0"
                width="24"
                height="24"
                fill="rgba(0, 0, 0, 0)"
              />
            </svg>
          </a>

          <a
            href="https://twitter.com/vooaxis"
            target="_blank"
            class="cursor-pointer p-2 hover:text-gray-200 text-gray-400 rounded-full transition-colors duration-300"
          >
            <svg
              class="h-6 w-6"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M19.633 7.997c.013.175.013.349.013.523c0 5.325-4.053 11.461-11.46 11.461c-2.282 0-4.402-.661-6.186-1.809c.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721a4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062c.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973a4.02 4.02 0 0 1-1.771 2.22a8.073 8.073 0 0 0 2.319-.624a8.645 8.645 0 0 1-2.019 2.083z"
                fill="currentColor"
              />
              <rect
                x="0"
                y="0"
                width="24"
                height="24"
                fill="rgba(0, 0, 0, 0)"
              />
            </svg>
          </a>

          <a
            href="https://www.instagram.com/vooaxis"
            target="_blank"
            class="cursor-pointer p-2 hover:text-gray-200 text-gray-400 rounded-full transition-colors duration-300"
          >
            <svg
              class="h-6 w-6"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M20.947 8.305a6.53 6.53 0 0 0-.419-2.216a4.61 4.61 0 0 0-2.633-2.633a6.606 6.606 0 0 0-2.186-.42c-.962-.043-1.267-.055-3.709-.055s-2.755 0-3.71.055a6.606 6.606 0 0 0-2.185.42a4.607 4.607 0 0 0-2.633 2.633a6.554 6.554 0 0 0-.419 2.185c-.043.963-.056 1.268-.056 3.71s0 2.754.056 3.71c.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632a6.584 6.584 0 0 0 2.185.45c.963.043 1.268.056 3.71.056s2.755 0 3.71-.056a6.59 6.59 0 0 0 2.186-.419a4.615 4.615 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.187c.043-.962.056-1.267.056-3.71c-.002-2.442-.002-2.752-.058-3.709zm-8.953 8.297c-2.554 0-4.623-2.069-4.623-4.623s2.069-4.623 4.623-4.623a4.623 4.623 0 0 1 0 9.246zm4.807-8.339c-.597 0-1.078-.482-1.078-1.078a1.077 1.077 0 1 1 2.155 0c0 .596-.482 1.078-1.077 1.078z"
                fill="currentColor"
              />
              <circle cx="11.994" cy="11.979" r="3.003" fill="currentColor" />
              <rect
                x="0"
                y="0"
                width="24"
                height="24"
                fill="rgba(0, 0, 0, 0)"
              />
            </svg>
          </a>

          <a
            href="https://www.youtube.com/channel/UCZMyk_9kKsTPyLE0w0gyeHw"
            target="_blank"
            class="cursor-pointer p-2 hover:text-gray-200 text-gray-400 rounded-full transition-colors duration-300"
          >
            <svg
              class="h-6 w-6"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765c1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6l5.207 3.005l-5.212 2.995z"
                fill="currentColor"
              />
              <rect
                x="0"
                y="0"
                width="24"
                height="24"
                fill="rgba(0, 0, 0, 0)"
              />
            </svg>
          </a>

          <a
            href="https://www.pinterest.com/vooaxis"
            target="_blank"
            class="cursor-pointer p-2 hover:text-gray-200 text-gray-400 rounded-full transition-colors duration-300"
          >
            <svg
              class="h-6 w-6"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M11.99 2C6.472 2 2 6.473 2 11.99c0 4.232 2.633 7.85 6.35 9.306c-.088-.79-.166-2.006.034-2.868c.182-.78 1.172-4.966 1.172-4.966s-.299-.599-.299-1.484c0-1.388.805-2.425 1.808-2.425c.853 0 1.264.64 1.264 1.407c0 .858-.546 2.139-.827 3.327c-.235.994.499 1.805 1.479 1.805c1.775 0 3.141-1.872 3.141-4.575c0-2.392-1.719-4.064-4.173-4.064c-2.843 0-4.512 2.132-4.512 4.335c0 .858.331 1.779.744 2.28a.3.3 0 0 1 .069.286c-.076.315-.245.994-.277 1.133c-.044.183-.145.222-.335.134c-1.247-.581-2.027-2.405-2.027-3.871c0-3.151 2.289-6.045 6.601-6.045c3.466 0 6.159 2.469 6.159 5.77c0 3.444-2.171 6.213-5.184 6.213c-1.013 0-1.964-.525-2.29-1.146l-.623 2.374c-.225.868-.834 1.956-1.241 2.62a10 10 0 0 0 2.958.445c5.517 0 9.99-4.473 9.99-9.99S17.507 2 11.99 2"
                fill="currentColor"
              />
              <rect
                x="0"
                y="0"
                width="24"
                height="24"
                fill="rgba(0, 0, 0, 0)"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  components: {},
  computed: {
    ...mapGetters(["footerLinks"]),

    getDate() {
      return new Date().getFullYear();
    },
  },
  data() {
    return { routeType: "General" };
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      this.routeType = to.name;
    },
  },
};
</script>
<style scoped>
.glass-effect {
  background-color: rgba(38, 38, 38, 0.9);
  backdrop-filter: blur(7px);
}

.blur {
  background-color: rgba(38, 38, 38, 0.97);
  backdrop-filter: blur(20px);
}
</style>
